<template>
  <div id="main">
    <v-header @searchInfo="searchInfo" @getWordCount="getWordCount"></v-header>
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        ref="blog"
        :articleList="articleListCopy"
        :articleCount="articleCount"
        :wordCount="wordCount"
        :userIpCount="userIpCount"
        :currentPage="currentPage"
        :pageNum="pageNum"
        :userInfo="userInfo"
        :isLoading="isLoading"
        :categories="categories"
        :nowCategorie="nowCategorie"
        :tags="tags"
        :nowTagName="nowTagName"
        @getCategories="getCategories"
        @getTagArticle="getTagArticle"
        @getColumnArticle="getColumnArticle"
        @getArticleList="getArticleList"
        @getWordCount="getWordCount"
        @geUserIpCount="geUserIpCount"
        @showMessage="showMessage"
        @clearArticleList="clearArticleList"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      ref="blog"
      :articleList="articleListCopy"
      :articleCount="articleCount"
      :wordCount="wordCount"
      :userIpCount="userIpCount"
      :currentPage="currentPage"
      :pageNum="pageNum"
      :userInfo="userInfo"
      :isLoading="isLoading"
      :categories="categories"
      :nowCategorie="nowCategorie"
      :tags="tags"
      :nowTagName="nowTagName"
      @getCategories="getCategories"
      @getTagArticle="getTagArticle"
      @getColumnArticle="getColumnArticle"
      @getArticleList="getArticleList"
      @getWordCount="getWordCount"
      @geUserIpCount="geUserIpCount"
      @showMessage="showMessage"
      @clearArticleList="clearArticleList"
    ></router-view>
    <v-Message
      :messageShow="messageShow"
      :sendMessage="sendMessage"
    ></v-Message>
  </div>
</template>

<script>
import Header from "@/components/common/header/header";
import Message from "@/components/common/Message/Message";
import cookie from "@/utils/cookie";
import {
  queryOneUser,
  queryArticleList,
  getTotalCategories,
  getArticleTotalNumber,
  getIpNumber,
  setIpInfo
} from "@/bmob";
export default {
  data() {
    return {
      messageShow: false,
      sendMessage: "",
      articleList: [], //文章列表
      articleListCopy: this.articleList, //文章列表备份
      articleCount: 0, //文章实际总数
      wordCount: 0, //文章总字数
      userIpCount: 0, //访客数
      currentPage: 1, //当前页
      pageNum: 20, //每页总数
      categories: [], //文章的分类列表
      tags: [], //文章的标签列表
      nowCategorie: "", //当前选中的分类
      nowTagName: "", //当前选中的标签
      userInfo: {}, //用户信息
      isLoading: false,
      scrollEl: ""
    };
  },
  created() {
    // 获取用户信息
    this.getUserInfo();
    //初始化获取文章总字数
    this.getWordCount();
    //初始化获取访客数
    this.geUserIpCount();
    //初始化获取文章类型
    this.getCategories();
    //清空数据
    this.clearArticleList();
    //重新加载数据
    this.getArticleList();
    //设置访客信息
    this.setUserIpInfo();
  },
  watch: {
    $route(to, from) {
      //从需要权限的地方去不需要权限的地方
      if (from.path.indexOf("/BAM") > -1 && to.path.indexOf("/BAM") === -1) {
        //校验用户是否登录并获取当前登录用户信息
        this.getUserInfo(true);
      }
      //判断是否需要重新加载数据(如果在当前搜索跳转页搜索就需要重新加载数据)
      if (to.path.indexOf("/blog") > -1) {
        this.$nextTick(() => {
          //清空数据
          this.clearArticleList();
          //重新加载数据
          this.getArticleList();
        });
      }
    },
    articleList(newVal) {
      this.articleListCopy = this.articleList;
    }
  },
  methods: {
    // 搜索
    searchInfo(keyWord) {
      this.articleList = getSearchInfo(keyWord, this.articleList);
    },
    // 根据关键字返回对应信息
    getSearchInfo(keyWord, list) {
      if (keyWord) {
        //查找题目相关数据
        const aboutTitle = this.searchAbout(list, "mainTitle", keyWord);
        //查找简介相关数据
        const aboutIntro = this.searchAbout(list, "intro", keyWord);
        //合并结果和去重
        let newAry = this.uniqueFunc(
          [...aboutTitle, ...aboutIntro],
          "objectId"
        );
        //循环对关键字进行高亮着色
        newAry.forEach((item, index) => {
          //对字段数据内容进行高亮着色
          item.mainTitle = this.markHightLight(item.mainTitle, keyWord); //标题关键字高亮
          item.intro = this.markHightLight(item.intro, keyWord); //简介内容高亮
        });
        return newAry;
      } else {
        return list;
      }
    },
    // 根据标签返回对应信息
    getTagInfo(tagName, list) {
      if (tagName) {
        //查找标签相关数据
        const aboutTagList = this.searchAbout(list, "tags", tagName);
        //合并结果和去重
        let newAry = this.uniqueFunc(aboutTagList, "objectId");
        return newAry;
      } else {
        return list;
      }
    },
    // 数组去重
    uniqueFunc(arr, uniId) {
      const res = new Map();
      return arr.filter(
        item => !res.has(item[uniId]) && res.set(item[uniId], 1)
      );
    },
    // 对内容进行高亮着色
    markHightLight(str, keyWord) {
      //高亮着色
      let replaceReg = new RegExp(keyWord, "i");
      let ary = str.match(replaceReg);
      if (ary) {
        ary.forEach((item, index) => {
          let replaceString = `<span style="color:red">${item}</span>`;
          str = str.replace(replaceReg, replaceString);
        });
      }
      return str;
    },
    // 获取文章数据数组指定字段包含关键词的数组
    searchAbout(list, colm, keyWord) {
      const mylist = JSON.parse(JSON.stringify(list));
      //查找文章相关的字段
      var searchList = mylist.filter(item => {
        // 匹配关键字正则（不区分大小写）
        let reg = new RegExp(keyWord, "i");
        let str = item[colm];
        // 如果是数组，合并一下
        if (Array.isArray(item[colm])) {
          str = item[colm].join(",");
        }
        return str ? str.match(reg) : false;
      });
      return searchList;
    },
    // 获取用户id
    getUserId() {
      return (
        window.localStorage.getItem("userId") ||
        this.$route.query.userId ||
        undefined
      );
    },
    // 校验用户是否登录并获取当前登录用户信息
    getUserInfo(needLogin) {
      const userId = this.getUserId();
      queryOneUser(userId)
        .then(result => {
          //查询用户信息
          result.userId = result.id;
          this.userInfo = result; //存储用户信息
        })
        .catch(err => {
          //需要登录的，没有session，未登录（未按步骤操作）
          needLogin && this.$router.push({ path: "/login" });
        });
    },
    //获取文章列表
    getArticleList(pageData = { currentPage: 1, pageNum: 20 }) {
      const userId = this.getUserId();
      //增加分类查询条件
      pageData.col = this.nowCategorie;
      //增加标签查询条件（该条件由于vip限制失效，在接口已注释掉了，不会起作用）
      pageData.tags = this.nowTagName;
      //改变加载状态
      this.isLoading = true;
      //获取文章列表
      queryArticleList({ userId, pageData })
        .then(async result => {
          let newArticleList = this.articleList;
          newArticleList.push(...result.articleList); //获取到的文章列表片段信息（不是全部，分段加载）
          // 根据关键词过滤下列表
          newArticleList = this.getSearchInfo(
            this.$route.query.keyWord,
            newArticleList
          );
          // 根据标签过滤下列表
          newArticleList = this.getTagInfo(this.nowTagName, newArticleList);
          this.articleList = newArticleList; // 过滤结果赋值
          this.articleCount = result.count; //实际文章总数
          this.currentPage = pageData.currentPage;
          this.pageNum = pageData.pageNum;
          //初始化获取文章标签
          this.getBlogTags();
          this.isLoading = false;
          //自动分段加载所有文章(开启将自动分片加载全部文章)
          // this.autoLoadArticle();
        })
        .catch(err => {
          this.showMessage(err);
          this.isLoading = false;
          setTimeout(() => {
            this.messageShow = false;
          }, 1500);
        });
    },
    //自动分段加载所有文章
    autoLoadArticle() {
      let allPageNum = Math.ceil(this.articleCount / this.pageNum);
      if (this.currentPage < allPageNum) {
        //当前页小于总页数，才允许加载文章列表数据
        // 页码，分页用，默认第一页
        this.currentPage++;
        // 请求列表数据
        this.getArticleList({
          currentPage: this.currentPage,
          pageNum: this.pageNum
        });
      }
    },
    //获取当前选中的分类的文章
    getColumnArticle(col) {
      //防止重复点击
      if (this.isLoading) {
        return;
      }
      this.nowCategorie = col;
      //清空原有数据
      this.clearArticleList();
      // 请求相关分类列表数据
      this.getArticleList();
      //置顶
      this.setTop();
    },
    //获取当前选中的标签的文章
    getTagArticle(tagName) {
      //防止重复点击
      if (this.isLoading) {
        return;
      }
      this.nowTagName = tagName;
      //清空原有数据
      !tagName && this.clearArticleList();
      // 请求相关分类列表数据
      this.getArticleList();
      //置顶
      this.setTop();
    },
    // 获取文章分类列表
    getCategories() {
      const userId = this.getUserId();
      getTotalCategories({ userId })
        .then(result => {
          this.categories = result;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取所有文章标签
    getBlogTags() {
      let newList = [];
      let tagsList = [];
      this.articleList.forEach(item => {
        item.tags.forEach(element => {
          newList.push(element);
          newList = [...new Set(newList)];
        }, this);
      }, this);
      newList.forEach(item => {
        tagsList.push(item);
      });
      this.tags = tagsList;
    },
    // 获取所有文章字数统计
    getWordCount() {
      //统计所有文章字数
      const userId = this.getUserId();
      getArticleTotalNumber({ userId })
        .then(result => {
          this.wordCount = result[0] ? result[0]._sumWordCount : 0;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取访客数
    geUserIpCount() {
      //统计访客数
      const userId = this.getUserId();
      getIpNumber({ userId })
        .then(result => {
          this.userIpCount = result[0] ? result[0]._count : 0;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 清除文章信息
    clearArticleList() {
      //清空原有数据
      this.articleList = [];
    },
    //显示提示信息
    showMessage(msg) {
      //节流阀
      if (!this.messageShow) {
        this.messageShow = true;
        this.sendMessage = msg;
        setTimeout(() => {
          this.messageShow = false;
        }, 1500);
      }
    },
    // 设置用户ip信息
    setUserIpInfo() {
      // 判断是否有ip信息缓存，没有再获取并缓存和记录
      let ipInfo = cookie.getCookie("ipInfo") || "";
      if (!ipInfo) {
        ipInfo = {
          ipv4: window.returnCitySN.cip,
          area: window.returnCitySN.cname,
          citycode: window.returnCitySN.cid,
          userId: this.getUserId(),
          ...this.getMobSysInfo() // 设备信息
        };
        // 缓存ip信息，过期时间为1天
        cookie.setCookie("ipInfo", ipInfo, 1);
        // 记录访客ip
        setIpInfo(ipInfo);
      }
    },
    // 获取设备信息
    getMobSysInfo() {
      Array.prototype.contains = function(needle) {
        for (i in this) {
          if (this[i].indexOf(needle) > 0) return i;
        }
        return -1;
      };

      const device_type = navigator.userAgent; // 获取userAgent信息
      const md = new MobileDetect(device_type); // 初始化mobile-detect
      let os = md.os(); // 获取系统
      let model = "";
      if (os == "iOS") {
        // ios系统的处理
        os = md.os() + md.version("iPhone");
        model = md.mobile();
      } else if (os == "AndroidOS") {
        // Android系统的处理
        os = md.os() + md.version("Android");
        const sss = device_type.split(";");
        var i = sss.contains("Build/");
        if (i > -1) {
          model = sss[i].substring(0, sss[i].indexOf("Build/"));
        }
      }
      return {
        os,
        model
      };
    },
    // 滚动条置顶
    setTop() {
      this.$nextTick(() => {
        //置顶
        window.pageYOffset = 0;
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      });
    },
    // 获取滚动条当前的位置
    getScrollTop() {
      return this.scrollEl.scrollTop;
    },
    // 获取当前可视范围的高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },
    // 获取文档完整的高度
    getScrollHeight() {
      return this.scrollEl.scrollHeight;
    },
    // 滚动事件触发下拉加载
    onScroll() {
      //满足滚动条底部触发获取文章列表
      if (
        this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <=
        10
      ) {
        let allPageNum = Math.ceil(this.articleCount / this.pageNum);
        //判断文章列表加载状态用来防止重复触发请求
        if (!this.isLoading && this.currentPage < allPageNum) {
          //不是加载状态且当前页小于总页数，才允许加载文章列表数据
          // 页码，分页用，默认第一页
          this.currentPage++;
          // 请求列表数据
          this.getArticleList({
            currentPage: this.currentPage,
            pageNum: this.pageNum
          });
        }
      }
    }
  },
  mounted() {
    this.scrollEl = document.getElementById("main");
    //添加鼠标滚动事件
    this.scrollEl.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    //删除鼠标滚动事件
    this.scrollEl.removeEventListener("scroll", this.onScroll);
  },
  components: {
    "v-header": Header,
    "v-Message": Message
  }
};
</script>
<style lang="less" scoped>
#main {
  margin-top: 50px;
  overflow: auto;
  height: calc(~"100vh - 50px");
}
</style>



// WEBPACK FOOTER //
// App.vue?01b92eaa